import cx from 'classnames';
import PropTypes from 'prop-types';

import styles from './HamburgerButton.module.scss';

const propTypes = {
  active: PropTypes.bool,
  rootStyle: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  rowStyle: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  onClick: PropTypes.func,
};

const defaultProps = {
  active: false,
  rootStyle: null,
  rowStyle: null,
  onClick() {},
};

function HamburgerButton({ active, rootStyle, rowStyle, onClick }) {
  const className = cx({
    [styles.button]: true,
    [styles.buttonActive]: active,
  });

  return (
    <button
      aria-label="hamburger-button"
      className={className}
      style={rootStyle}
      type="button"
      onClick={onClick}
    >
      <div className={styles.row} style={rowStyle} />
      <div className={styles.row} style={rowStyle} />
      <div className={styles.row} style={rowStyle} />
    </button>
  );
}

HamburgerButton.propTypes = propTypes;
HamburgerButton.defaultProps = defaultProps;

export default HamburgerButton;
